/** Soft initials fills (43F1). Literal class strings so Tailwind can see them. */
export const CONVERSATION_AVATAR_TONES = [
  "bg-[#e3f1ec] text-[#22735d]",
  "bg-[#e6ecf8] text-[#3c64a3]",
  "bg-[#f7e8ef] text-[#a2557a]",
  "bg-[#f4eedf] text-[#8a6a1f]",
  "bg-[#ebe8f7] text-[#5d4fa3]",
  "bg-[#e2eff2] text-[#2c6c7c]",
] as const;

/** Stable tone for a contact profile, so the same person keeps the same color everywhere. */
export function conversationAvatarTone(seed: number): string {
  const count = CONVERSATION_AVATAR_TONES.length;
  const index = Number.isFinite(seed) ? ((Math.trunc(seed) % count) + count) % count : 0;
  return CONVERSATION_AVATAR_TONES[index]!;
}
